// dependencies
import React from "react";
import { formatDistanceToNow, format } from "date-fns";
// components
import Button from "Components/Button";
import TextInput from "../../Components/Inputs/Text";
import Table from "../../Components/TableLite/TableLite";
// css
import css from "./ETL";
// hooks
import { useETLPage } from "./hooks";

const dateFormat = "PPPPp";

// Main component
const ETL = () => {
	const {
		searchID,
		etlData,
		reportingData,
		isLoadingReport,
		isGetReportError,
		handleSearchChange,
		handleKeyDown,
		handleSearch,
	} = useETLPage();

	// QUEUE ATTRIBUTES
	const attributes = etlData?.data?.queueData;
	const ageOfOldestMessageInSeconds = etlData?.data?.ageOfOldestMessage?.Maximum;
	const currentDate = new Date();
	const ageOfOldestMessageFormatted = ageOfOldestMessageInSeconds
		? formatDistanceToNow(new Date(currentDate.getTime() - ageOfOldestMessageInSeconds * 1000))
		: "...";

	// UI
	const reviewReportsView = <Table isLoading={isLoadingReport} columns={columns} rows={[reportingData?.data]} />;

	return (
		<div className={css.Dashboard}>
			<div className={`${css.dashRow} ${css.center}`}>
				<div className={css.dashBox}>
					<div className={`${css.innerBox} ${css.statsContainer}`}>
						<div className={css.statWrapper}>
							<div className={css.dashboardLabel}>Queue Size</div>
							<div className={css.dashboardValue}>{attributes?.ApproximateNumberOfMessages || "..."}</div>
						</div>
					</div>
				</div>
				<div className={css.dashBox}>
					<div className={`${css.innerBox} ${css.statsContainer}`}>
						<div className={css.statWrapper}>
							<div className={css.dashboardLabel}>Longest Wait Time</div>
							<div className={css.dashboardValue}>{ageOfOldestMessageFormatted}</div>
						</div>
					</div>
				</div>
			</div>

			<div className={css.searchContainer}>
				<div className={css.searchBox}>
					<div className={css.label}>Review Report ID</div>
					<TextInput value={searchID} onChange={handleSearchChange} onKeyDown={handleKeyDown} />
				</div>
				<div className={css.searchBox}>
					<div className={css.label} />
					<Button disabled={searchID.length === 0} onClick={handleSearch}>
						Search
					</Button>
				</div>
			</div>

			<div className={css.dashRow}>
				<div className={`${css.statsContainer}`}>
					{reportingData?.data?.found && !isGetReportError ? reviewReportsView : "No report found"}
				</div>
			</div>
		</div>
	);
};

// Table columns
const columns = [
	{
		id: "review_name",
		label: "Review Name",
		isSortable: false,
		width: "33%",
		getter: (row) => <div>{row.reportName}</div>,
	},
	{
		id: "subject_name",
		label: "Subject Name",
		isSortable: false,
		width: "33%",
		getter: (row) => <div>{row.reviewSubjectName}</div>,
	},
	{
		id: "last_updated",
		label: "Last Updated",
		isSortable: false,
		width: "33%",
		getter: (row) => <div>{format(new Date(row.lastUpdated), dateFormat)}</div>,
	},
];

export default ETL;
